import { AppThunkDispatch } from '@Reducers/index';

import { SuggestionsApi } from '@ClientApi/suggestionsApi';
import { IUnexpensedItem } from '@Shared/expense_data';

export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const SET_SUGGESTIONS_LOADING = 'SET_SUGGESTIONS_LOADING';
export const REMOVE_SUGGESTION_ITEM = 'REMOVE_SUGGESTION_ITEM';

export class SetSuggestions {
  readonly type = SET_SUGGESTIONS;

  constructor(public payload: IUnexpensedItem[]) {}
}

export class SetSuggestionsLoading {
  readonly type = SET_SUGGESTIONS_LOADING;

  constructor(public payload: boolean) {}
}

export class RemoveSuggestionItem {
  readonly type = REMOVE_SUGGESTION_ITEM;

  constructor(public payload: IUnexpensedItem) {}
}

export const fetchSuggestions = () => async (dispatch: AppThunkDispatch) => {
  dispatch(new SetSuggestionsLoading(true));
  const suggestions: any = await SuggestionsApi.getPosted();
  dispatch(new SetSuggestions(suggestions));
  dispatch(new SetSuggestionsLoading(false));
};

export type SuggestionsActions = SetSuggestions | RemoveSuggestionItem | SetSuggestionsLoading;
